const env = {
    API: "https://to-platform.lexartlabs.com/pd/new_api/public",
    PENDING: "https://to-platform.lexartlabs.com/pd/new_api/public/products/pending?page=",
    DESCARTADOS: "https://to-platform.lexartlabs.com/pd/new_api/public/products/removed?page=",
    USE_TAXO_TABLE: true,
}
export default env;